import { render, staticRenderFns } from "./Com_DiscreteSlider.vue?vue&type=template&id=794154c1&scoped=true&"
import script from "./Com_DiscreteSlider.vue?vue&type=script&lang=js&"
export * from "./Com_DiscreteSlider.vue?vue&type=script&lang=js&"
import style0 from "./Com_DiscreteSlider.vue?vue&type=style&index=0&id=794154c1&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "794154c1",
  null
  
)

export default component.exports